import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const MarketplaceVendorProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `MarketplaceVendor/${props.marketplaceVendorId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `MarketplaceVendor`, method: 'POST', payload: props, multipart: true, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `MarketplaceVendor/${props.marketplaceVendorId}`, method: 'PUT', payload: props, multipart: true, secure: true });
    }, [execute]);

    const updateRecordFranchise = useCallback(async (props) => {
        await execute({ scope: 'update', url: `MarketplaceVendor/${props.marketplaceVendorId}/Franchises`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: 'MarketplaceVendor', method: 'GET', secure: true });
    }, [execute]);  

    const listFranchiseRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `MarketplaceVendor/${props.marketplaceVendorId}/Franchises`, method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `MarketplaceVendor/${props.marketplaceVendorId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, listFranchiseRecords, newRecord, deleteRecord, updateRecord, updateRecordFranchise, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useMarketplaceVendorStore = () => React.useContext(Context);
